import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkboxField", "emailFieldContainer"]

  toggleEmailFieldVisibility() {
    if (this.checkboxFieldTarget.checked === true) {
      this.emailFieldContainerTarget.classList.remove("d-none")
    }
    else {
      this.emailFieldContainerTarget.classList.add("d-none")
    }
  }
}


